export default "__VITE_ASSET__QFDmF$PH__"